import React, {useMemo} from 'react';
import styled, {useTheme} from "styled-components";
import {SummonerItem} from "../../common/ImageSrc";

const LensWrapper = styled.div`
  .imgItem {
    border-radius: 50%;
  }

`;

const EmptyDiv = styled.div`

`;
const QuestBox = styled.div`
  .imgItem {
    border-radius: 999px;
  }
`;

const ItemWithMythic = ({item, array, lens, margin, emptyColor, isWin, questItem, showQuestItem}) => {
    const theme = useTheme();
    const itemMemo = useMemo(() => {
        try {
            if (Array.isArray(array)) {
                return array;
            }
            return [];
        } catch (e) {
            return [];
        }
    }, [array]);

    return (
        <>
            {itemMemo.map((data, index) => {
                return (
                    <div className={'img_wrapper'} key={index}>
                        <SummonerItem itemId={data} key={index}
                                      emptyColor={isWin ? theme.color.blue_100 : theme.color.red_500}/>
                    </div>
                )
            })}
            {lens &&
                <LensWrapper>
                    <SummonerItem itemId={lens}/>
                </LensWrapper>
            }
            {showQuestItem &&
                <QuestBox class={'quest_item'}>
                    <SummonerItem itemId={questItem}
                                  emptyColor={isWin ? theme.color.blue_100 : theme.color.red_500}/>
                </QuestBox>
            }
        </>
    );
};

export default ItemWithMythic;